import { api, publicApi } from "./api"

export const userService = {
    login: data => publicApi.post(`/auth/token/`, data).then(res => {
        localStorage.setItem("access", res.data.access)
        localStorage.setItem("refresh", res.data.refresh)
    }),
    logout: () => {
        localStorage.removeItem("access")
        localStorage.removeItem("refresh")
    },
    getUserInfo: () => api.get(`/auth/current_user/`),
}